import { Dialog } from "@headlessui/react";
import { IconX } from "@tabler/icons-react";
import { useForm } from "react-hook-form";
import SelectField from "../../../components/SelectField";
import InputText from "../../../components/InputText";
import Button from "../../../components/Button";
import DatePicker from "../../../components/DatePicker";
import PriceInput from "../../../components/PriceInput";
import { PRODUCT_QUALITY } from "../../../constant";

function AddUnRegisterItemPopup({
  isOpen,
  close,
  onSubmit,
  contract_purchase_date,
}: {
  isOpen: boolean;
  close: () => void;
  onSubmit: (values: any) => void;
  contract_purchase_date: Date;
}) {
  const {
    control,
    handleSubmit,
    formState: { isValid, isDirty },
  } = useForm({
    shouldUnregister: true,
  });

  return (
    <Dialog
      open={isOpen}
      as="div"
      className="relative z-10 focus:outline-none"
      onClose={close}
    >
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto bg-black/50">
        <div className="flex min-h-full items-center justify-center p-4">
          <form
            onSubmit={(e) => {
              e.stopPropagation();
              e.preventDefault();
              handleSubmit(onSubmit)();
              if (isValid && isDirty) {
                close();
              }
            }}
            id="line-item"
            className="w-full rounded-xl bg-white relative max-w-[640px] sm:p-6 p-4 grid gap-y-6"
          >
            <div className="flex items-center justify-between gap-3 text-gray-800">
              <h2 className="text-lg font-semibold">Add an Item</h2>
              <button onClick={close}>
                <IconX />
              </button>
            </div>
            <div className="grid gap-3 min-[540px]:grid-cols-2 grid-cols-1">
              <InputText
                name="manufacturer"
                type="text"
                control={control}
                label="Manufacturer"
                required
              />
              <InputText
                name="model_number"
                type="text"
                control={control}
                label="Model Number"
                required
                inputProps={{ maxLength: 80 }}
              />
              <InputText
                name="serial_number"
                type="text"
                control={control}
                label="Serial Number"
              />
              <DatePicker
                name="purchase_date_of_product"
                control={control}
                label="Purchase Date Of Product"
                disableFuture
                required
                defaultValue={contract_purchase_date}
              />
              <DatePicker
                name="delivery_date_of_product"
                control={control}
                label="Delivery Date Of Product"
                disableFuture
                required
              />
              <PriceInput
                name="product_retail_price"
                control={control}
                label="Product Retail Price"
                required
              />
              <InputText
                name="quantity"
                control={control}
                label="Quantity"
                type="number"
                required
                defaultValue={1}
              />
              <InputText
                name="product_sku"
                type="text"
                control={control}
                label="Product Sku"
                required
              />
              <SelectField
                name="product_quality"
                control={control}
                label="Product Quality"
                defaultValue={PRODUCT_QUALITY[0]}
                options={PRODUCT_QUALITY}
              />
              <InputText
                name="product_description"
                type="text"
                control={control}
                label="Product Description"
              />
            </div>

            <div className="flex items-center justify-end gap-3">
              <Button
                type="button"
                variant="gray"
                btnClassName="w-[120px]"
                onClick={close}
              >
                Close
              </Button>
              <Button type="submit" variant="blue" btnClassName="w-[120px]">
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Dialog>
  );
}

export default AddUnRegisterItemPopup;
